'use strict';

const RegionalInfoStore = require('../stores/RegionalInfoStore');
const { URL: { queryKey: { ipAddress } } } = require('bunsen/helpers/uri');

let promise;

const regionalInfoActions = {
    loadRegionalInfo(actionContext, payload, done) {
        const regionalInfoStore = actionContext.getStore(RegionalInfoStore);
        const model = regionalInfoStore.getRegionalInfoModel();

        if (!promise) {
            promise = model
                .getInfo({ ipAddress })
                .then(() => {
                    actionContext.dispatch('regionalInfo:loaded');
                    done();
                })
                .catch(err => {
                    actionContext.dispatch('regionalInfo:error', { message: err });
                    done(err);
                });
        }

        return promise;
    },
};

module.exports = regionalInfoActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/regionalInfoActions.es.js